import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import type { IFundingBannerInfoItemProps } from './types'

export const FundingBannerInfoItem = (props: IFundingBannerInfoItemProps) => {
  const { options } = props

  return (
    <div className="fundingBannerInfoItem">
      <div className="fundingBannerInfoItem__icon">
        <Icon component={options.icon} />
      </div>
      <div className="fundingBannerInfoItem__text">{options.text}</div>
    </div>
  )
}
